// src/cert/iso42001.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const ISO42001 = () => {
    return (
        <div className="cert-page">
            <div className="cert-header">
                <h1>ISO/IEC 42001:2023 प्रमाणन</h1>
                <p>कृत्रिम बुद्धिमत्ता व्यवस्थापन प्रणाली (Artificial Intelligence Management System)</p>
            </div>

            <div className="cert-content">
                <section>
                    <h2>ISO/IEC 42001:2023 म्हणजे काय?</h2>
                    <p>
                        ISO/IEC 42001 is an international standard that specifies requirements for establishing, implementing, maintaining, and continually improving an Artificial Intelligence Management System (AIMS) within organizations. It is designed for entities providing or utilizing AI-based products or services, ensuring responsible development and use of AI systems.

                        Why is ISO/IEC 42001 important?

                        ISO/IEC 42001 is the worlds first AI management system standard, providing valuable guidance for this rapidly changing field of technology. It addresses the unique challenges AI poses, such as ethical considerations, transparency, and continuous learning. For organizations, it sets out a structured way to manage risks and opportunities associated with AI, balancing innovation with governance.

                        Framework for managing risk and opportunities

                        Demonstrate responsible use of AI

                        Traceability, transparency and reliability

                        Cost savings and efficiency gains
                    </p>
                </section>

                <section>
                    <h2>प्रमुख फायदे</h2>
                    <ul>
                        <li>AI जोखीम (Bias, Privacy, Safety) नियंत्रित होतात</li>
                        <li>नैतिक AI वापर आणि पारदर्शकता सुनिश्चित</li>
                        <li>कायदेशीर अनुपालन (AI Act, GDPR, NIST)</li>
                        <li>ग्राहक आणि नियामकांचा विश्वास वाढतो</li>
                        <li>AI मॉडेल्सची कार्यक्षमता आणि विश्वासार्हता सुधारते</li>
                    </ul>
                </section>

                <section className="apply-section">
                    <h2>ISO/IEC 42001:2023 साठी अर्ज करा</h2>
                    <ApplyForm certification="ISO/IEC 42001:2023" />
                </section>
            </div>
        </div>
    );
};

export default ISO42001;